import Handsontable from 'handsontable';
import { CellValue, RowObject } from 'handsontable/common';
import { empty } from 'handsontable/helpers/dom/element';
import { CellProperties } from 'handsontable/settings';
import { isObject } from 'lodash';

import { prepareOptions } from 'SharedDir/service/fields/table.functions';

/**
 * Редактор для ячеек таблицы, значение которых - идентификатор значения стандартного каталога.
 */
export default class CatalogEditor extends Handsontable.editors.SelectEditor {
  select!: HTMLSelectElement;

  getValue(): any {
    const originalValue = super.getValue();
    const numericVersion = parseInt(originalValue, 10);
    if (numericVersion === Number.NaN) {
      return originalValue;
    }

    return Number(originalValue);
  }

  prepare(
    row: number,
    col: number,
    prop: string | number,
    TD: HTMLTableCellElement,
    originalValue: any,
    cellProperties: CellProperties
  ): void {
    Handsontable.editors.BaseEditor.prototype.prepare.call(
      this,
      row,
      col,
      prop,
      TD,
      originalValue,
      cellProperties
    );
    const {
      selectOptions,
      optionLabel = 'name',
      optionValue = 'id',
      uniqueValues = true,
    } = this.cellProperties;

    let options;
    if (typeof selectOptions === 'function') {
      options = prepareOptions(selectOptions(this.row, this.col, this.prop));
    } else {
      options = prepareOptions(selectOptions);
    }

    let optionList = Object.values(options);

    if (uniqueValues) {
      const alreadyUsedOptions = this.hot.getDataAtCol(col);
      optionList = optionList.filter(
        (option) =>
          option[optionValue] === originalValue || !alreadyUsedOptions.includes(option[optionValue])
      );
    }

    let child;

    /* eslint-disable no-cond-assign */
    while ((child = this.select.lastChild)) {
      this.select.removeChild(child);
    }

    optionList.forEach((option: any) => {
      const optionElement = this.hot.rootDocument.createElement('option');
      optionElement.value = option[optionValue];
      optionElement.innerHTML = option[optionLabel];
      this.select.appendChild(optionElement);
    });
  }
}
